import { render } from "./eb-button.vue?vue&type=template&id=ad1b2260"
import script from "./eb-button.vue?vue&type=script&lang=ts"
export * from "./eb-button.vue?vue&type=script&lang=ts"
script.render = render

export default script